import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { assetListRequest } from '../../../redux/asset/asset.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";

const AssetsList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { assetListSuccess, assetListError } = useSelector(state => state.asset)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [selectedTab, setSelectedTab] = useState(0)

    const TAB_ITEMS = {
        ALL: 'ALL',
        ASSIGNED_ASSETS: 'ASSIGNED ASSETS'
    }
    // const TAB_ITEMS = {
    //     ...(isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET) && { ALL: 'ALL' }),
    //     ASSIGNED_ASSETS: 'ASSIGNED ASSETS'
    // }

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ASSET_LIST, true)
            fetchBusinessList()
        }
        if (isLoggedInUserEmployee(user)) {
            fetchAssetList(selectedTab)
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ASSET_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ASSET_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(assetListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(assetListError)) {
            setLoading(false)
        }
    }, [assetListSuccess, assetListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchAssetList(selectedTab)
        }
    }, [selectedLocation])

    const fetchAssetList = (tabIndex) => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
            if (tabIndex === 1) {
                data.assignedTo = user.data.userDetails.userId
                data.assignedToUserType = user.data.userDetails.userType
            }
        } else if (isLoggedInUserEmployee(user)) {
            if (!isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
            if (tabIndex === 1) {
                data.assignedTo = user.data.userDetails.employeeId
                data.assignedToUserType = user.data.userDetails.userType
            }
        }

        dispatch(assetListRequest(data))
    }

    const handleViewDetail = (item) => {
        navigate(ROUTES.assets.detail, {
            state: {
                assetId: item.assetId,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
            }
        })
    }

    const handleAddAssetClick = () => {
        navigate(ROUTES.assets.add)
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.ASSET.ADD_ASSET) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.ASSET, PERMISSION_SUB_TYPE.ASSET.ADD_ASSET, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.ASSET, PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const handleTabSelect = (item) => {
        if (item === TAB_ITEMS.ALL) {
            setSelectedTab((prevTab) => {
                const newTab = 0
                fetchAssetList(0)
                return newTab
            })
        } else {
            setSelectedTab((prevTab) => {
                const newTab = 1
                fetchAssetList(1)
                return newTab
            })
        }
    }

    const getStatusClassName = (status) => {
        if (status === APP_CONSTANTS.ASSET_STATUS.AVAILABLE) {
            return 'al-status-label al-status-green'
        } else if (status === APP_CONSTANTS.ASSET_STATUS.ASSIGNED) {
            return 'al-status-label al-status-grey'
        } else if (status === APP_CONSTANTS.ASSET_STATUS.DISPOSED) {
            return 'al-status-label al-status-red'
        } else if (status === APP_CONSTANTS.ASSET_STATUS.MAINTENANCE) {
            return 'al-status-label al-status-yellow'
        } else {
            return 'al-status-label'
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Assets' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET) && <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === 0 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ALL) }}>{TAB_ITEMS.ALL}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === 1 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ASSIGNED_ASSETS) }}>{TAB_ITEMS.ASSIGNED_ASSETS}</div>
                </div>}
                {!isNull(assetListSuccess) && !isEmpty(assetListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Category</th>
                                <th scope="col" className="text-center">Serial Number</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Assign To</th>
                                <th scope="col" className="text-center">Assign To Id</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assetListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{!isEmpty(element.category) ? removeSpecialCharAndChangeToPascal(element.category) : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.serialNumber) ? element.serialNumber : '-'}</td>
                                    <td className="text-center">
                                        <div className={getStatusClassName(element.status)}>
                                            {!isEmpty(element.status) ? removeSpecialCharAndChangeToPascal(element.status) : '-'}
                                        </div>
                                    </td>
                                    <td className="text-center">{!isEmpty(element.assigneToDetails) ? `${element.assigneToDetails.firstName} ${element.assigneToDetails.lastName}` : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.assigneToDetails) ? element.assigneToDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? element.assigneToDetails.employeeCode : removeSpecialCharAndChangeToPascal(element.assigneToDetails.userType) : '-'}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(assetListError) && <div className="content-error">{assetListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.ADD_ASSET) && <div className="vl-fab-container" onClick={() => handleAddAssetClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AssetsList